export const DANG_NHAP_THANH_CONG = "Đăng nhập thành công";

export const LOI_CHUA_CHON_NGUOI_DUNG = "Vui lòng chọn người dùng";

export const LOI_CHUA_CHON_QUYEN = "Vui lòng chọn quyền";

export const TAO_VAI_TRO_THANH_CONG = "Tạo vai trò thành công";

export const THONG_TIN_VAI_TRO_DUOC_CAP_NHAT_THANH_CONG =
  "Thông tin vai trò được cập nhật thành công";

export const THEM_NGUOI_DUNG_VAO_NHOM_THANH_CONG =
  "Người dùng đã được thêm vào nhóm thành công";

export const XOA_VAI_TRO_THANH_CONG = "Xóa vai trò thành công";

export const XOA_QUYEN_TRONG_VAI_TRO_THANH_CONG =
  "Quyền trong vai trò được xóa thành công";

export const THEM_QUYEN_VAO_VAI_TRO_THANH_CONG =
  "Thêm quyền vào vai trò thành công";

export const THEM_QUYEN_VAO_NGUOI_DUNG_THANH_CONG =
  "Thêm quyền vào người dùng thành công";

export const THEM_VAI_TRO_VAO_NGUOI_DUNG_THANH_CONG =
  "Thêm vai trò vào người dùng thành công";

export const THEM_GROUP_VAO_NGUOI_DUNG_THANH_CONG =
  "Thêm nhóm người dùng vào người dùng thành công";

export const XOA_VAI_TRO_THUOC_NGUOI_DUNG_THANH_CONG =
  "Xóa vai trò khỏi người dùng thành công";

export const XOA_GROUP_THUOC_NGUOI_DUNG_THANH_CONG =
  "Xóa nhóm người dùng khỏi người dùng thành công";

export const XOA_NGUOI_DUNG_THANH_CONG =
  "Xóa người dùng thành công";

export const CHUYEN_TRANG_THAI_NGUOI_DUNG_THANH_CONG =
  "Chuyển trạng thái người dùng thành công";

export const THONG_TIN_NGUOI_DUNG_DUOC_CAP_NHAT_THANH_CONG =
  "Thông tin người dùng được cập nhật thành công";

export const THEM_NGUOI_DUNG_THANH_CONG =
  "Thêm người dùng thành công";

export const CAP_NHAT_MAT_KHAU_NGUOI_DUNG_THANH_CONG =
    "Cập nhật mật khẩu thành công";
export const THEM_MOI_CHUC_VU_THANH_CONG = "Thêm mới chức vụ thành công";

export const SUA_CHUC_VU_THANH_CONG = "Sửa chức vụ thành công";

export const XOA_CHUC_VU_THANH_CONG = "Xóa chức vụ thành công";

export const THEM_MOI_NHOM_CHUC_VU_THANH_CONG =
  "Thêm mới nhóm chức vụ thành công";

export const SUA_NHOM_CHUC_VU_THANH_CONG = "Sửa nhóm chức vụ thành công";

export const XOA_NHOM_CHUC_VU_THANH_CONG = "Xóa nhóm chức vụ thành công";

export const THEM_MOI_CAP_DON_VI_THANH_CONG =
  "Thêm mới cấp đơn vị thành công";

export const SUA_CAP_DON_VI_THANH_CONG = "Sửa cấp đơn vị thành công";

export const XOA_CAP_DON_VI_THANH_CONG = "Xóa cấp đơn vị thành công";

export const THEM_DM_HE_THONG_THANH_CONG = "Thêm danh mục hệ thống thành công";

export const SUA_DM_HE_THONG_THANH_CONG = "Sửa danh mục hệ thống thành công";

export const XOA_DM_HE_THONG_THANH_CONG = "Xóa danh mục hệ thống thành công";
export const THEM_DM_MENU_HE_THONG_THANH_CONG =
  "Thêm danh mục menu hệ thống thành công";

export const SUA_DM_MENU_HE_THONG_THANH_CONG =
  "Sửa danh mục menu hệ thống thành công";

export const XOA_DM_MENU_HE_THONG_THANH_CONG =
  "Xóa danh mục menu hệ thống thành công";
export const CAP_NHAT_THU_TU_THANH_CONG = "Cập nhật thứ tự thành công";

export const CAP_NHAT_CAN_BO_THANH_CONG = "Cập nhật cán bộ thành công";
export const TAO_CAN_BO_THANH_CONG = "Tạo cán bộ thành công";
export const XOA_CAN_BO_THANH_CONG = "Xóa cán bộ thành công";
export const UPLOAD_THANH_CONG = "Upload hình ảnh thành công";
export const UPLOAD_KHONG_THANH_CONG = "Upload hình ảnh không thành công, vui lòng thử lại";
export const CAP_NHAT_MENU_CAN_BO_THANH_CONG =
  "Cập nhật phân quyền menu thành công";
export const CAP_NHAT_DON_VI_THANH_CONG = "Cập nhật đơn vị thành công";
export const TAO_DON_VI_THANH_CONG = "Tạo đơn vị thành công";
export const XOA_DON_VI_THANH_CONG = "Xóa đơn vị thành công";
export const SUA_NHOM_MENU_THANH_CONG = "Cập nhật nhóm menu thành công";
export const TAO_NHOM_MENU_THANH_CONG = "Tạo nhóm menu thành công";
export const XOA_NHOM_MENU_THANH_CONG = "Xóa nhóm menu thành công";
export const GUI_DUYET_THONG_BAO_THANH_CONG = "Gửi duyệt thông báo thành công.";

export const LUU_NHAP_THONG_BAO_THANH_CONG = "Lưu nháp thông báo thành công.";

export const CAP_NHAT_THONG_BAO_THANH_CONG = "Cập nhật thông báo thành công.";

export const XOA_THONG_BAO_THANH_CONG = "Xóa thông báo thành công.";

export const DUYET_THONG_BAO_THANH_CONG = "Duyệt thông báo thành công.";

export const TU_CHOI_DUYET_THONG_BAO_THANH_CONG =
  "Từ chối duyệt thông báo thành công.";

export const DANG_THONG_BAO_THANH_CONG = "Đăng thông báo thành công.";

export const TAO_LICH_LAM_VIEC_THANH_CONG = "Tạo lịch làm việc thành công.";

export const MO_THONG_BAO_THANH_CONG = "Mở thông báo thành công.";

export const DONG_THONG_BAO_THANH_CONG = "Đóng thông báo thành công.";

export const CAP_NHAT_LICH_LAM_VIEC_THANH_CONG =
  "Cập nhật lịch làm việc thành công.";
export const THEM_CAN_BO_VAO_NGUOI_DUNG = "Thêm thành công";
export const CAP_NHAT_ACTIVE_NGUOI_DUNG = "Cập nhật trạng thái thành công";


export const THEM_MOI_GROUP_THANH_CONG = "Thêm nhóm người dùng thành công";
export const CAP_NHAT_GROUP_THANH_CONG = "Cập nhật nhóm người dùng thành công";
export const XOA_GROUP_THANH_CONG = "Xóa nhóm người dùng thành công";
export const XOA_USER_THANH_CONG = "Xóa người dùng thành công";
export const XOA_QUYEN_TRONG_GROUP_THANH_CONG = "Xóa quyền khỏi nhóm người dùng thành công";
export const THEM_QUYEN_VAO_GROUP_THANH_CONG = "Thêm quyền vào nhóm người dùng thành công";
export const THEM_VAI_TRO_VAO_GROUP_THANH_CONG = "Thêm vai trò vào nhóm người dùng thành công";
export const XOA_VAI_TRO_THUOC_GROUP_THANH_CONG = "Xóa vai trò thuộc nhóm người dùng thành công";

export const CAP_NHAT_APP_THANH_CONG = "Cập nhật thông tin ứng dụng thành công";
export const THEM_MOI_APP_THANH_CONG = "Thêm mới ứng dụng thành công";
export const XOA_APP_THANH_CONG = "Xóa ứng dụng thành công";
export const DUPLICATE_APP = "Tên hoặc mã bị trùng, vui lòng thử lại";
export const CAP_NHAT_ACTIVE_APP = "Cập nhật trạng thái thành công";

export const VUI_LONG_CHON_PHAM_VI = "Vui lòng chọn phạm vi";
